import { Box, Button, Stack, Typography } from "@mui/material";

import { WarningOctagonIcon } from "@phosphor-icons/react";
import type { FallbackRender } from "@sentry/react";

const ErrorFallback: FallbackRender = ({ error, resetError }) => {
  const message =
    error instanceof Error ? error.message : "An unexpected error occurred.";

  return (
    <Box
      sx={{
        minHeight: "100vh",
        minWidth: "100vw",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        bgcolor: "background.default",
        px: 2,
      }}
    >
      <Stack
        alignItems="center"
        textAlign="center"
        spacing={3}
        sx={{
          maxWidth: 480,
          width: "100%",
          p: {
            xs: 3,
            sm: 5
          },
          borderRadius: 4,
          border: "1px solid",
          borderColor: "divider",
          bgcolor: "background.paper",
          boxShadow: "0 8px 32px rgba(0,0,0,0.18)",
          backdropFilter: "blur(12px)",
        }}
      >
        {/* Icon */}
        <Box
          sx={{
            width: 72,
            height: 72,
            borderRadius: "50%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            bgcolor: "error.main",
            opacity: 0.9,
          }}
        >
          <WarningOctagonIcon size={36} weight="duotone" color="#fff" aria-hidden />
        </Box>

        {/* Heading */}
        <Stack spacing={0.5}>
          <Typography variant="text20B" color="textPrimary">
            Something went wrong
          </Typography>
          <Typography variant="text15L" color="textSecondary">
            {message}
          </Typography>
        </Stack>

        {/* Actions */}
        <Stack direction={{
          xs: "column",
          sm: "row"
        }} spacing={1.5} width="100%">
          <Button
            variant="contained"
            color="primary"
            fullWidth
            onClick={resetError}
          >
            Try again
          </Button>
          <Button
            variant="outlined"
            color="inherit"
            fullWidth
            onClick={() => window.location.assign("/")}
          >
            Go home
          </Button>
        </Stack>
      </Stack>
    </Box>
  );
};

export default ErrorFallback;
